<template>
  <div id="dashboard">
    <div class="dashboard_tit">환영합니다. {{userInfoDetail.userName}} 님.</div>
    <div class="dashboard_desc">
      저압 모뎀 웹사이트
      <template v-if="userInfoDetail.userRole === 2 || userInfoDetail.userRole === 3">
        |
        <template v-if="userInfoDetail.affiliateCode != null">
          <template v-for="afc in afcList" v-if="afc.codeValue === userInfoDetail.affiliateCode">{{afc.codeName}}</template>
        </template>
        <template v-if="userInfoDetail.officeCode != null">
          <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}</template>
        </template>
      </template>
    </div>
    <div class="dashboard_wrap">
      <div>
        <div class="dashboard_menu_tit">빠른 메뉴</div>
        <div class="dashboard_menu_wrap">
          <div class="dashboard_menu_item" @click="movePath('/ModemAS/RequestList')">
            <div class="border_top"></div>
            <div class="tit">모뎀A/S</div>
            <div class="desc">모뎀의 "A/S"를 요청하고 관리할 수 있습니다.</div>
            <div class="btn_link">바로가기</div>
          </div>
          <div class="dashboard_menu_item" @click="movePath('/ShadowQuality/RequestList')">
            <div class="border_top"></div>
            <div class="tit">음영∙품질 개선</div>
            <div class="desc">모뎀의 "음영∙품질" 개선을 요청 및 관리할 수 있습니다.</div>
            <div class="btn_link">바로가기</div>
          </div>
          <div class="dashboard_menu_item" @click="movePath('/LineShutDown/RequestList')">
            <div class="border_top"></div>
            <div class="tit">회선관리</div>
            <div class="desc">모뎀 사용의 "정지"를 요청하고 정지된 모뎀을 "해제"할 수 있습니다.</div>
            <div class="btn_link">바로가기</div>
          </div>
          <div class="dashboard_menu_item" @click="movePath('/Charge/List')">
            <div class="border_top"></div>
            <div class="tit">청구관리</div>
            <div class="desc">모뎀이용에 대한 이용금액과 계산서 등에 대한 청구를 확인할 수 있습니다.</div>
            <div class="btn_link">바로가기</div>
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard_cont">
      <div class="dashboard_stat_box">
        <div class="dashboard_stat_tit">▶ {{mySession.userRole != null && (mySession.userRole === 2 || mySession.userRole === 3) ? userInfoDetail.userName + '님의' : '현재 모든'}} 모뎀요청 현황 [각 단계의 숫자를 클릭하면 바로 이동합니다]</div>
        <div class="dashboard_stat_table_wrap">
          <table class="col4">
            <colgroup>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
            </colgroup>
            <tr>
              <th colspan="4">모뎀 A/S 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>접수</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'as_' + index" v-for="(item, index) in as">
                <span v-if="index === '1'" @click="movePath('/ModemAS/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/ModemAS/AcceptedList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/ModemAS/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '4'" @click="movePath('/ModemAS/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col5">
            <colgroup>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
            </colgroup>
            <tr>
              <th colspan="5">음영∙품질 개선 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>보류</td>
              <td>접수</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'sq_' + index" v-for="(item, index) in sq">
                <span v-if="index === '1'" @click="movePath('/ShadowQuality/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/ShadowQuality/PendingList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/ShadowQuality/AcceptedList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '4'" @click="movePath('/ShadowQuality/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '5'" @click="movePath('/ShadowQuality/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col3">
            <colgroup>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
            </colgroup>
            <tr>
              <th colspan="3">정지 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'stop_' + index" v-for="(item, index) in stop">
                <span v-if="index === '1'" @click="movePath('/LineShutDown/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/LineShutDown/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/LineShutDown/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col3">
            <colgroup>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
            </colgroup>
            <tr>
              <th colspan="3">정지해제 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'cancel_' + index" v-for="(item, index) in cancel">
                <span v-if="index === '1'" @click="movePath('/LineStartup/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/LineStartup/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/LineStartup/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="dashboard_stat_box" v-if="mySession.userRole != null && (mySession.userRole === 2 || mySession.userRole === 3)">
        <div class="dashboard_stat_tit">
          ▶ <template v-for="ofc1 in ofc1List" v-if="ofc1.codeValue === userInfoDetail.officeCode.substring(0, 5)">{{ofc1.codeName}}의</template> 모뎀요청 현황 [각 단계의 숫자를 클릭하면 바로 이동합니다]
        </div>
        <div class="dashboard_stat_table_wrap">
          <table class="col4">
            <colgroup>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
              <col style="width: 25%"/>
            </colgroup>
            <tr>
              <th colspan="4">모뎀 A/S 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>접수</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'asOf_' + index" v-for="(item, index) in asOf">
                <span v-if="index === '1'" @click="movePath('/ModemAS/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/ModemAS/AcceptedList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/ModemAS/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '4'" @click="movePath('/ModemAS/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col5">
            <colgroup>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
              <col style="width: 20%"/>
            </colgroup>
            <tr>
              <th colspan="5">음영∙품질 개선 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>보류</td>
              <td>접수</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'sqOf_' + index" v-for="(item, index) in sqOf">
                <span v-if="index === '1'" @click="movePath('/ShadowQuality/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/ShadowQuality/PendingList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/ShadowQuality/AcceptedList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '4'" @click="movePath('/ShadowQuality/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '5'" @click="movePath('/ShadowQuality/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col3">
            <colgroup>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
            </colgroup>
            <tr>
              <th colspan="3">정지 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'stopOf_' + index" v-for="(item, index) in stopOf">
                <span v-if="index === '1'" @click="movePath('/LineShutDown/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/LineShutDown/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/LineShutDown/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
          <table class="col3">
            <colgroup>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
              <col style="width: 33.3333%"/>
            </colgroup>
            <tr>
              <th colspan="3">정지해제 현황</th>
            </tr>
            <tr>
              <td>요청</td>
              <td>처리중</td>
              <td>완료</td>
            </tr>
            <tr>
              <td class="num" :key="'cancelOf_' + index" v-for="(item, index) in cancelOf">
                <span v-if="index === '1'" @click="movePath('/LineStartup/RequestList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '2'" @click="movePath('/LineStartup/ProgressList')">{{numberWithComma(item)}}</span>
                <span v-if="index === '3'" @click="movePath('/LineStartup/CompleteList')">{{numberWithComma(item)}}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="dashboard_stat_box">
        <div class="dashboard_stat_tit">▶ 사업별 모뎀집계 현황 [<span @click="movePath('/Modem/List')">모뎀현황상세보기</span>]</div>
        <div class="dashboard_stat_table_wrap">
          <table>
            <colgroup>
              <col style="width: 16.6666%"/>
              <col style="width: 33.3333%"/>
              <col style="width: 16.6666%"/>
              <col style="width: 16.6666%"/>
              <col style="width: 16.6666%"/>
              <col style="width: 16.6666%"/>
            </colgroup>
            <tr>
              <th>사업구분</th>
              <th>사업구축</th>
              <th>사용</th>
              <th>정지</th>
              <th>합계</th>
            </tr>
            <tr :key="'project_' + index" v-for="(item, index) in project">
              <td :rowspan="duplicateProject[item.projectType]" v-if="!item.duplicateProject">{{item.projectName}}</td>
              <td>{{item.structName}}</td>
              <td class="num"><span>{{numberWithComma(item.useCount)}}</span></td>
              <td class="num"><span>{{numberWithComma(item.stopCount)}}</span></td>
              <td class="num"><span>{{numberWithComma(item.totalCount)}}</span></td>
            </tr>
            <tr>
              <td colspan="2">합계</td>
              <td class="num"><span>{{numberWithComma(projectTotal.use)}}</span></td>
              <td class="num"><span>{{numberWithComma(projectTotal.stop)}}</span></td>
              <td class="num"><span>{{numberWithComma(projectTotal.total)}}</span></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import amsHome from '../../script/amsHome'
import {defaultLoadingOptions} from '../../script/defaultConfig'
import noticeApi from '../notice/notice'
import NoticePopup from '../notice/NoticePopup.vue'

const POPUP_NOTICE_SIZE = 5

export default {
  data () {
    return {
      mySession: {},
      userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
      userInfoDetail: JSON.parse(sessionStorage.getItem('userInfoDetail')),
      afcList: [],
      ofcList: [],
      ofc1List: [],
      // Data
      as: {},
      sq: {},
      stop: {},
      cancel: {},
      asOf: {},
      sqOf: {},
      stopOf: {},
      cancelOf: {},
      project: {},
      duplicateProject: {},
      projectTotal: {
        use: 0,
        stop: 0,
        total: 0
      }
    }
  },
  mounted () {
    this.$emit('setMenu', 'Dashboard')

    this.openNoticePopups()

    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
        let intervalCnt = 0
        let interval = setInterval(() => {
          if (common.checkValidateData('session', sessionStorage.getItem('afcList')) &&
            common.checkValidateData('session', sessionStorage.getItem('ofcList'))) {
            clearInterval(interval)
            this.afcList = JSON.parse(sessionStorage.getItem('afcList'))
            this.ofcList = JSON.parse(sessionStorage.getItem('ofcList'))
            this.ofc1List = this.getOfc1List()
            this.init()
          } else if (intervalCnt > 10) {
            clearInterval(interval)
            common.amsAlert('retry', '필수 데이터를 불러오지 못했습니다.')
          } else {
            intervalCnt++
          }
        }, 200)
      }
    })
  },
  methods: {
    openNoticePopups () {
      noticeApi.getNotice({ showPopup: true, size: POPUP_NOTICE_SIZE }, response => {
        const data = response && response.data ? response.data : response
        const result = data && data.result !== undefined ? data.result : data
        const body = result && result.body !== undefined ? result.body : result

        let list = []

        if (body && Array.isArray(body.list)) {
          list = body.list
        } else if (Array.isArray(body)) {
          list = body
        }

        list.forEach((notice, index) => {
          if (this.isNoticeHiddenToday(notice.noticePid)) return

          const modalName = 'noticePopup_' + notice.noticePid
          this.$modal.show(NoticePopup, {
            notice: notice,
            userInfo: this.userInfo || {},
            showTodayOption: true,
            modalName: modalName
          }, {
            name: modalName,
            width: 760,
            height: 'auto',
            adaptive: true,
            scrollable: true,
            classes: 'popup_modal',
            shiftY: 0.15 + (index * 0.03)
          })
        })
      })
    },
    isNoticeHiddenToday (noticePid) {
      const userPid = (this.userInfo && this.userInfo.userPid) || 'anonymous'
      const key = 'notice_hide_today_' + userPid + '_' + noticePid
      const expiresAt = Number(localStorage.getItem(key) || 0)

      if (!expiresAt) return false
      if (Date.now() > expiresAt) {
        localStorage.removeItem(key)
        return false
      }
      return true
    },
    movePath (path) {
      this.$router.push(path)
    },
    getOfc1List () {
      return this.ofcList.filter(item => { return item.codeLevel === 0 })
    },
    init () {
      let vueLoadingOverlay = this.$loading.show(defaultLoadingOptions)
      amsHome.getHome({}, response => {
        console.log('getHome', response)
        vueLoadingOverlay.hide()
        if (response.data.resultCode === 1) {
          let data = response.data.result.body
          this.as = this.getData(data.as, 4)
          this.sq = this.getData(data.sq, 5)
          this.stop = this.getData(data.stop, 3)
          this.cancel = this.getData(data.cancel, 3)
          if (this.mySession.userRole != null && (this.mySession.userRole === 2 || this.mySession.userRole === 3)) {
            this.asOf = this.getData(data['as_of'], 4)
            this.sqOf = this.getData(data['sq_of'], 5)
            this.stopOf = this.getData(data['stop_of'], 3)
            this.cancelOf = this.getData(data['cancel_of'], 3)
          }
          this.duplicateProject = {}
          let duplicateProject = ''
          for (let i = 0; i < data.project.length; i++) {
            data.project[i].duplicateProject = false
            if (i === 0) {
              this.duplicateProject[data.project[i].projectType] = 1
              duplicateProject = data.project[i].projectType
            } else {
              if (data.project[i].projectType === duplicateProject) {
                this.duplicateProject[data.project[i].projectType]++
                data.project[i].duplicateProject = true
              } else {
                this.duplicateProject[data.project[i].projectType] = 1
                duplicateProject = data.project[i].projectType
              }
            }
            this.projectTotal.use += data.project[i].useCount
            this.projectTotal.stop += data.project[i].stopCount
            this.projectTotal.total += data.project[i].totalCount
          }
          this.project = data.project
        } else {
          common.amsAlert('retry', '대시보드 통합정보를 불러오지 못했습니다.')
        }
      })
    },
    getData (list, step) {
      let resultMap = {}
      list.forEach(item => {
        resultMap[item.step] = item.cnt
      })
      for (let i = 1; i <= step; i++) {
        if (resultMap[i] == null) {
          resultMap[i] = 0
        }
      }
      return resultMap
    },
    numberWithComma (value) {
      return common.numberWithComma(value)
    }
  }
}
</script>

<style scoped>
#dashboard {
  display: flex;
  flex-direction: column;
  margin: 36px auto 46px;
}

.dashboard_tit {
  width: 1200px;
  margin: auto;
  line-height: 36px;
  color: #171721;
  font-size: 28px;
  font-weight: 700;
  text-align: left;
}

.dashboard_desc {
  width: 1200px;
  margin: auto;
  line-height: 24px;
  color: #8083A3;
  font-size: 16px;
  font-weight: 400;
  text-align: left;
}

.dashboard_wrap {
  min-width: 1200px;
  margin: 23px 0 0;
  background: url('../../assets/dashboard/bg_dashboard.png') center center no-repeat;
  background-size: cover;
}

.dashboard_wrap > div {
  display: flex;
  flex-direction: column;
  padding: 23px 0 43px;
  background: rgba(7, 56, 129, 0.70);
}

.dashboard_wrap > div > .dashboard_menu_tit {
  width: 1200px;
  margin: auto;
  line-height: 21px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  text-align: left;
}

.dashboard_wrap > div > .dashboard_menu_wrap {
  display: flex;
  width: 1200px;
  margin: 18px auto 0;
  gap: 24px;
}

.dashboard_menu_wrap > .dashboard_menu_item {
  position: relative;
  width: 25%;
  border: 1px solid #E4E6E8;
  border-radius: 6px;
  background: #ffffff;
  cursor: pointer;
}

.dashboard_menu_wrap > .dashboard_menu_item:nth-child(1) {
  background: #ffffff url('../../assets/dashboard/ic_dashboard_menu_1.svg') 17px 36px no-repeat;
  background-size: 72px 72px;
}

.dashboard_menu_wrap > .dashboard_menu_item:nth-child(2) {
  background: #ffffff url('../../assets/dashboard/ic_dashboard_menu_2.svg') 17px 36px no-repeat;
  background-size: 72px 72px;
}

.dashboard_menu_wrap > .dashboard_menu_item:nth-child(3) {
  background: #ffffff url('../../assets/dashboard/ic_dashboard_menu_3.svg') 17px 36px no-repeat;
  background-size: 72px 72px;
}

.dashboard_menu_wrap > .dashboard_menu_item:nth-child(4) {
  background: #ffffff url('../../assets/dashboard/ic_dashboard_menu_4.svg') 17px 36px no-repeat;
  background-size: 72px 72px;
}

.dashboard_menu_item > div {
  text-align: left;
}

.dashboard_menu_item > .border_top {
  position: absolute;
  top: -1px;
  right: -1px;
  left: -1px;
  height: 4px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  background: #30A8FF;
}

.dashboard_menu_item > .tit {
  margin: 32px 0 0 108px;
  line-height: 24px;
  color: #171721;
  font-size: 16px;
  font-weight: 700;
}

.dashboard_menu_item > .desc {
  margin: 10px 10px 0 108px;
  line-height: 21px;
  color: #8083A3;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -1px;
  word-break: keep-all;
}

.dashboard_menu_item > .btn_link {
  width: 67px;
  margin: 24px 20px 20px auto;
  background: url('../../assets/dashboard/ic_dashboard_arrow.svg') left center no-repeat;
  line-height: 18px;
  color: #171721;
  font-size: 12px;
  font-weight: 700;
  text-indent: 20px;
}

.dashboard_cont {
  display: flex;
  flex-direction: column;
  width: 1200px;
  margin: 25px auto 0;
  gap: 25px;
}

.dashboard_cont > .dashboard_stat_box {
  border: 1px solid #EBEAED;
  border-radius: 4px;
}

.dashboard_stat_box > .dashboard_stat_tit {
  height: 52px;
  border-bottom: 1px solid #EBEAED;
  line-height: 52px;
  color: #2E2C34;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
  text-indent: 26px;
}

.dashboard_stat_box > .dashboard_stat_tit > span {
  color: #00A1E2;
  cursor: pointer;
}

.dashboard_stat_box > .dashboard_stat_table_wrap {
  display: flex;
  margin: 24px 16px;
  gap: 20px;
}

.dashboard_stat_table_wrap > table {
  width: 100%;
  border-collapse: collapse;
}

.dashboard_stat_table_wrap > table.col3 {
  width: 27%;
}

.dashboard_stat_table_wrap > table.col4 {
  width: 36%;
}

.dashboard_stat_table_wrap > table.col5 {
  width: 45%;
}

.dashboard_stat_table_wrap > table tr {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.dashboard_stat_table_wrap > table th,
.dashboard_stat_table_wrap > table td {
  height: 45px;
}

.dashboard_stat_table_wrap > table th {
  border-top: 1px solid #000000;
  border-bottom: 1px solid #000000;
  background: #D9D9D9;
}

.dashboard_stat_table_wrap > table td {
  border-right: 1px solid #D7D7D7;
  border-bottom: 1px solid #D7D7D7;
  background: #FEFEFE;
}

.dashboard_stat_table_wrap > table td:last-child {
  border-right: none;
}

.dashboard_stat_table_wrap > table tr:last-child td {
  border-bottom: 1px solid #000000;
}

.dashboard_stat_table_wrap > table td.num {
  font-size: 16px;
}

.dashboard_stat_table_wrap > table td.num > span {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue